import {
  DeviceTypes,
  MODALITIES,
} from '../constants/common.constant';
import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const DEVICE_URL = '/ris/devices/v1';

export interface ParamsGetDevices {
  active?: boolean;
  code?: string;
  created_at_from?: string;
  created_at_to?: string;
  hostname?: string;
  institution_ids?: string[];
  limit?: number;
  modality?: MODALITIES;
  name?: string;
  offset?: number;
  sort_field?: '' | 'active' | 'name' | 'institution_id' | 'updated_at';
  sort_order?: SORT_ORDER;
  source_aetitle?: string;
  types?: DeviceTypes[];
  updated_at_from?: string;
  updated_at_to?: string;
}
export interface ResponseGetDevices extends DefaultResponse {
  data: {
    active: boolean;
    api_key: string;
    code: string;
    created_at: string;
    description: string;
    hostname: string;
    id: string;
    institution_id: string;
    modality: string;
    name: string;
    port: number;
    sftp_public_key: string;
    sftp_user: string;
    source_aetitle: string;
    type: DeviceTypes;
    updated_at: string;
  }[];
}
export const getDevices = async (params: ParamsGetDevices = {}) => {
  const response = (await api({
    url: DEVICE_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetDevices>;

  return response.data;
};

export interface ParamsCreateDevice {
  institution_id: string;
  name: string;
  type: DeviceTypes;
  modality: string;
  source_aetitle: string;
  api_key: string;
  hostname: string;
  port?: number;
  active?: boolean;
  description?: string;
}
export const createDevice = async (data: ParamsCreateDevice) => {
  const response = (await api({
    url: DEVICE_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateDevice {
  name?: string;
  modality?: string;
  source_aetitle?: string;
  api_key?: string;
  hostname?: string;
  port?: number;
  active?: boolean;
  description?: string;
}
export const updateDevice = async (id: string, data: ParamsUpdateDevice) => {
  const response = (await api({
    url: `${DEVICE_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const deleteDevice = async (id: string) => {
  const response = (await api({
    url: `${DEVICE_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;

  return response;
};
